<template>
  <v-app>
    <Nav />
    <v-content>
      <router-view />
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Footer from "@/components/ui/Footer";
import Nav from "@/components/ui/Nav";
export default {
  components: { Footer, Nav },
  name: "App"
};
</script>
